import React, {useEffect, useState} from "react";
import Chip from "@material-ui/core/Chip";
import HTTPClient from "../HTTPClient";
import {getMessage} from "../util";

const getSeconds = async (end_date) => {

    const got_time = await HTTPClient({
        method: "get",
        url:
            process.env.REACT_APP_API_URL +
            "/now"
    });

    const now = new Date(got_time.data);
    const end = new Date(end_date);
    return  Math.round((end.getTime() - now.getTime()) / 1000);

}

const Clock = (props) => {
    const [distance, setDistance] = useState("00:00");
    const [secondsToEnd, setSecondsToEnd] = useState(100);


    useEffect(() => {
        let mounted = true;

        const hours = Math.floor((secondsToEnd % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((secondsToEnd % (60 * 60)) / 60);
        const seconds = (secondsToEnd % 60);
        if (secondsToEnd <= 0) {
            props.onTime();

        }
        const s_label = secondsToEnd > 0 ? ((minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds)) : "00:00";

        if (mounted) setDistance(hours > 0 ? (hours + ":" + s_label) : s_label);

        return () => { mounted = false };


    }, [props,secondsToEnd]);


    useEffect(() => {
        let mounted = true;

        let intervalId = null;
            (async () => {
                try {
                    let seconds = await getSeconds(props.end_date);
                    setSecondsToEnd(seconds);
                     intervalId = setInterval(() => {
                        (async () => {
                            // resync cada 5 segundos
                            if (seconds % 5 === 0) {
                                seconds = await getSeconds(props.end_date);
                            } else {
                                seconds--;
                            }
                            if (seconds < 0 ) {
                                clearInterval(intervalId);
                            }
                            if (mounted) setSecondsToEnd(seconds);
                        })()
                    }, 1000);


                } catch (error) {
                    setDistance(getMessage(props.meeting.meeting_type, 'synchronizing', props.messages));
                }
            })();

        return (() => {
            clearInterval(intervalId);
            mounted = false;
        });

        }, [props.end_date, props.meeting.meeting_type, props.messages]
    )


    return (
        <Chip label={distance} component={"span"}/>
    )
}

export default Clock;